import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { OptInsPatchCheckMapper } from "../../../../../utils/mappers/OptInsPatchMappers";
import { getModuleOptIns } from "../../../../../utils/optInsHelpers";
import { LENDER_SPECIFIC_OPTINS_LIST } from "../../../loanApplication/SummaryAndAdjust/config";
import LenderSpecificOptInsDialog from "./LenderSpecificOptInsDialog";
import { constructProgressEvent } from "../../../../../utils/constructProgressEvent";
import { useEventDispatcher } from "../../../../../utils/hooks/useEventDispatcher";

export default function LenderSpecificOptIns({ onOmit, onSuccess }) {
  const {
    state: {
      loan,
      optIns,
      lastActionsReferenceLastChange,
      lastActionsReference,
      currentModuleObject,
      participant,
    },
    dispatch,
  } = useContext(ProcessContext);

  const { dispatchEvent } = useEventDispatcher();
  const form = useForm();
  const { getValues } = form;

  const isActionTypeInLastActionsReference = (actionType) =>
    lastActionsReference?.some((element) => element.type === actionType);

  const [state, setState] = useState({
    lenderSpecificOptInsArray: [],
    showLenderSpecificOptInsDialog: false,
  });

  const { lenderSpecificOptInsArray, showLenderSpecificOptInsDialog } = state;

  useEffect(() => {
    loan && patchLenderSpecificOptInsAndGetOptIns();
  }, []);

  useEffect(() => {
    switch (true) {
      case isActionTypeInLastActionsReference(
        "REQUEST_GET_OPTIN_BY_LOAN_ID_AND_BORROWER_ID_FULFILLED"
      ):
        setLenderSpecificOptInsIfAvailable();
        break;
      default:
        break;
    }
  }, [lastActionsReferenceLastChange]);

  const acceptTerms = () => {
    submitOptInsConsents(getValues());
    onSuccess();
  };

  const submitOptInsConsents = (optInsValues) => {
    const conditions_check = [];
    if (optInsValues) {
      Object.keys(optInsValues).map((value) => {
        lenderSpecificOptInsArray.map((optIn) => {
          optIn.name === value &&
            conditions_check.push({
              id: optIn.condition_id,
              check: optInsValues[value],
            });
        });
      });
    }
    const dataToSend = OptInsPatchCheckMapper.hydrate({
      id: optIns.id,
      conditions_check,
      loanId: loan.id,
      borrowerId: participant.participantId,
    });
    dispatch({
      type: "REQUEST_PATCH_OPTIN_BY_ID_CONDITIONS_CHECK_IN_AND_SEQUENCE",
      payload: dataToSend,
    });
  };

  const patchLenderSpecificOptInsAndGetOptIns = () => {
    dispatch({
      type: "REQUEST_PATCH_LENDER_SPECIFIC_OPTIN_BY_ID_AND_SEQUENCE",
      payload: {
        optInsId: optIns.id,
        loanId: loan.id,
        borrowerId: participant.participantId,
      },
    });
  };

  const setLenderSpecificOptInsIfAvailable = () => {
    const filteredOptInsArrayByLenderSpecific = getModuleOptIns(
      LENDER_SPECIFIC_OPTINS_LIST,
      optIns
    );
    const areLenderOptInsNotYetChecked =
      filteredOptInsArrayByLenderSpecific.some(
        (optIn) => optIn?.checked === null
      );

    if (
      filteredOptInsArrayByLenderSpecific.length > 0 &&
      areLenderOptInsNotYetChecked
    ) {
      setState((s) => ({
        ...s,
        lenderSpecificOptInsArray: filteredOptInsArrayByLenderSpecific,
        showLenderSpecificOptInsDialog: true,
      }));
      const progressEvent = constructProgressEvent(
        currentModuleObject?.id,
        "LENDER_SPECIFIC_OPT_INS"
      );
      dispatchEvent(progressEvent);
    }
    if (filteredOptInsArrayByLenderSpecific.length === 0) {
      onOmit();
    }
    if (!areLenderOptInsNotYetChecked) {
      onOmit();
    }
  };

  return (
    showLenderSpecificOptInsDialog && (
      <LenderSpecificOptInsDialog
        className={"appear-anim"}
        form={form}
        showOptinsDialog={showLenderSpecificOptInsDialog}
        acceptTerms={acceptTerms}
        optInsArray={lenderSpecificOptInsArray}
      />
    )
  );
}
